module.exports = __webpack_public_path__ + "static/media/nfl.279733ff.png";